import { TServerErrorResponse, Meeting, GetTableListParams } from "@/types";
import { http } from "../httpHandler";
import { links } from "@/constants";

export const MEETING_GET = "meeting-get";
export const MEETING_ALL_GET = "meeting-all-get";
export const MEETING_COUNT_GET_PREV = "meeting-count-get-prev";
export const MEETING_COUNT_GET_NEXT = "meeting-count-get-next";

export const getMeeting = async (
  meetingId?: string | null,
  params?: {
    includeInvitees?: boolean;
    includeMeetingPrep?: boolean;
  },
): Promise<Meeting | undefined> => {
  if (!meetingId) return;
  try {
    const response = await http.get<Meeting>(
      links.meeting.meetingById(meetingId),
      {
        params: {
          includeMeetingPrep: true,
          ...params,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAllMeetings = async (
  params: Partial<GetTableListParams> & {
    includeInvitees?: boolean;
    includeBots?: boolean;
    startAt?: number;
    endAt?: number;
  },
): Promise<Meeting[]> => {
  try {
    const { startAt, endAt, ...data } = params;
    const response = await http.get<Meeting[]>(links.meeting.index, {
      params: {
        ...data,
        startAt,
        endAt,
        includeMeetingPrep: true,
      },
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAllMeetingsCount = async (
  params: Partial<GetTableListParams> & {
    includeInvitees?: boolean;
    startAt?: number;
    endAt?: number;
  },
): Promise<number> => {
  try {
    const response = await http.get<number>(links.meeting.count, {
      params,
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createMeeting = async (meeting: Meeting): Promise<Meeting> => {
  try {
    const response = await http.post<Meeting>(links.meeting.index, meeting);

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeeting = async (meeting: Meeting): Promise<Meeting> => {
  const { id, ...data } = meeting;
  try {
    const response = await http.patch<Meeting>(links.meeting.meetingById(id), {
      ...data,
    });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteMeeting = async (meetingId: string): Promise<number> => {
  try {
    const response = await http.delete<string>(
      links.meeting.meetingById(meetingId),
    );

    return response.status;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateMeetingRecordedStatus = async ({
  meetingId,
  recorded,
}: {
  meetingId: string;
  recorded: boolean;
}): Promise<Meeting> => {
  try {
    const response = await http.patch<Meeting>(
      links.meeting.meetingByIdRecorded(meetingId),
      { recorded },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
